<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Booking Details</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Form -->
        <form v-if="record" @submit.prevent="save">
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Employee ID/Name</label>
                <div class="col-md-1 fit-content">:</div>
                <div class="col-md-5 pl-md-0">
                    {{ record.EmployeeID + '/' + record.EmployeeName }}
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Type of Pass</label>
                <div class="col-md-1 fit-content">:</div>
                <div class="col-md-5 pl-md-0">
                    {{ record.PassName + ' (' + record.PassCode + ')' }}
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Number of Pass/E-Tickets</label>
                <div class="col-md-1 fit-content">:</div>
                <div class="col-md-5 pl-md-0">
                    {{ record.NumberOfPass }}
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Booking Date</label>
                <div class="col-md-1 fit-content">:</div>
                <div class="col-md-5 pl-md-0">
                    {{ record.BookingDateDisplay }}
                </div>
            </div>
            <div class="form-group row align-items-center" v-if="record.PassType == corporatePassType.physicalCard">
                <label class="col-md-2 mb-0">Collection Date</label>
                <div class="col-md-1 fit-content">:</div>
                <div class="col-md-5 pl-md-0">
                    {{ record.CollectionDateDisplay }}
                </div>
            </div>
            <div class="form-group row align-items-center" v-if="record.PassType == corporatePassType.physicalCard">
                <label class=" col-md-2 mb-0">Return Date</label>
                <div class="col-md-1 fit-content">:</div>
                <div class="col-md-5 pl-md-0">
                    {{ record.ReturnDateDisplay }}
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-md-2 mb-0">Status</label>
                <div class="col-md-1 fit-content">:</div>
                <div class="col-md-5 pl-md-0">
                    {{ record.Status }}
                </div>
            </div>
            <div class="form-group row align-items-center"
                v-if="record.PassType == corporatePassType.physicalCard && role == 'admin' && (record.Status == 'BOOKED' || record.Status == 'COLLECTED')">
                <label class="col-md-2 mb-0">Action</label>
                <div class="col-md-1 fit-content">:</div>
                <div class="col-md-5 pl-md-0" style="padding-top:12px">
                    <template v-if="record.Status != 'COLLECTED'">
                        <input type="radio" id="opt_collect" name="action" v-model="action" value="Collect" required />
                        <label for="opt_collect">Collect Pass</label>
                    </template>
                    <input type="radio" id="opt_return" name="action" v-model="action" value="Return" required />
                    <label for="opt_return">Return Pass</label>
                    <input type="radio" id="opt_cancel" name="action" v-model="action" value="Cancel" required />
                    <label for="opt_cancel">Cancel</label>
                </div>
            </div>
            <div class="form-group row align-items-center" v-if="record.PassType == corporatePassType.physicalCard">
                <label class="col-md-2 mb-0">Remarks (Optional)</label>
                <div class="col-md-1 fit-content">:</div>
                <div class="col-md-4 pl-md-0">
                    <textarea rows="2" v-model="record.Remarks" class="form-control" style="width:485px"
                        :disabled="!((role == 'employee' && record.Status == 'BOOKED') || (role == 'admin' && (record.Status == 'COLLECTED' || record.Status == 'BOOKED')))">
                    </textarea>
                </div>
            </div>
            <div class="form-group row align-items-center">
                <div class="col-md-3">
                    <button type="button" class="btn btn-secondary"
                        @click="$router.push({ name: 'managePassBookingHistory' })">
                        <i class="fa fa-reply mr-2"></i>Back
                    </button>
                </div>
                <div class="col-md-3 text-right"
                    v-if="(record.Status == 'BOOKED' || record.Status == 'COLLECTED') && record.PassType == corporatePassType.physicalCard">
                    <button type="submit" class="btn btn-primary" v-if="role == 'admin'">
                        <i class="fa fa-save mr-2"></i>Save
                    </button>
                    <button type="button" class="btn btn-danger" @click="cancel"
                        v-if="role == 'employee' && record.IsCancelAllowed == true && record.Status == 'BOOKED'">
                        <i class="fa fa-remove mr-2"></i>Cancel
                    </button>
                </div>
            </div>
        </form>
        <!-- /Form -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
    data() {
        return {
            record: null,
            action: ""
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        corporatePassType() {
            let type = {
                physicalCard: config.CORPORATE_PASS_TYPE_PHYSICAL_CARD,
                eTicket: config.CORPORATE_PASS_TYPE_ETICKET
            }
            return type;
        }
    },

    methods: {
        getCorporatePassBookingDetail() {
            let param = {
                Token: this.token,
                Id: this.$route.params.id
            };
            this.$store.state.isLoading = true;
            API.getCorporatePassBookingDetail(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        let data = response.data.record;
                        if (!data) this.$router.replace({ name: "managePassBookingHistory" });
                        this.record = data;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        saveCorporatePassBookingDetail(action) {
            let param = {
                Token: this.token,
                Id: this.$route.params.id,
                Action: action,
                Remarks: this.record.Remarks
            }
            let confirmationText = "Are you sure you want to " + (this.role == "admin" ? "save" : "cancel") + " the booking?";
            this.$swal({
                title: "Are you sure?",
                text: confirmationText,
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.saveCorporatePassBookingDetail(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            if (response.data.success) {
                                this.$router.replace({ name: "managePassBookingHistory" });
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        },
        save() {
            this.saveCorporatePassBookingDetail(this.action);
        },
        cancel() {
            this.saveCorporatePassBookingDetail("Cancel");
        }
    },

    created() {
        this.getCorporatePassBookingDetail();
    }
}
</script>

<style scoped>
.fit-content {
    max-width: fit-content;
}

input[type="radio"],
label[for] {
    cursor: pointer;
}

label[for] {
    margin-right: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Corppass/BookingDetail.vue